module.exports = __webpack_public_path__ + "img/48_20.b0cfcf56.png";